import PropTypes from 'prop-types';

import classNames from 'clsx';
import PaypalName from './icons/PaypalName';
import PaypalLogo from './icons/PaypalLogo';
import css from './payment.module.scss';

const PaypalButton = ({ inProgress, handlePaypal }) => (
  <div
    onClick={handlePaypal}
    className={classNames(css.paypalButton, css.altPaymentButton)}
    data-testid="paypalButton"
  >
    {inProgress && (
      // markup for animation overlay
      <p className={css.inProgress} data-testid="paypalProgressOverlay">
        <span></span>
        <span></span>
        <span></span>
      </p>
    )}
    <div className={css.paypalSvgWrapper}>
      <div className={css.paypalLogo}>
        <PaypalLogo />
      </div>
      <div className={css.paypalNameLogo}>
        <PaypalName />
      </div>
    </div>
  </div>
);

PaypalButton.propTypes = {
  inProgress: PropTypes.bool.isRequired,
  handlePaypal: PropTypes.func.isRequired,
};

export default PaypalButton;
